import './styles.scoped.css';
export default {
  "appbar": "awsui_appbar_hyvsj_znou3_93",
  "appbar-nav": "awsui_appbar-nav_hyvsj_znou3_117",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_znou3_121",
  "appbar-tools": "awsui_appbar-tools_hyvsj_znou3_125",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_znou3_166",
  "has-notifications-content": "awsui_has-notifications-content_hyvsj_znou3_173",
  "has-header": "awsui_has-header_hyvsj_znou3_179",
  "has-dynamic-overlap-height": "awsui_has-dynamic-overlap-height_hyvsj_znou3_179",
  "content-type-wizard": "awsui_content-type-wizard_hyvsj_znou3_180",
  "content-type-cards": "awsui_content-type-cards_hyvsj_znou3_183",
  "content-type-table": "awsui_content-type-table_hyvsj_znou3_184",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_znou3_187",
  "background": "awsui_background_hyvsj_znou3_221",
  "notifications-appbar-header": "awsui_notifications-appbar-header_hyvsj_znou3_224",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_znou3_236",
  "overlap": "awsui_overlap_hyvsj_znou3_242",
  "content": "awsui_content_hyvsj_znou3_180",
  "layout": "awsui_layout_hyvsj_znou3_329",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_znou3_411",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_znou3_438",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_znou3_441",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_znou3_445",
  "has-split-panel": "awsui_has-split-panel_hyvsj_znou3_459",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_znou3_459",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_znou3_471",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_znou3_474",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_znou3_489",
  "container": "awsui_container_hyvsj_znou3_497",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_znou3_514",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_znou3_519",
  "is-tools-open": "awsui_is-tools-open_hyvsj_znou3_522",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_znou3_522",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_znou3_522",
  "content-type-default": "awsui_content-type-default_hyvsj_znou3_542",
  "content-type-form": "awsui_content-type-form_hyvsj_znou3_542",
  "unfocusable": "awsui_unfocusable_hyvsj_znou3_583",
  "navigation-container": "awsui_navigation-container_hyvsj_znou3_591",
  "show-navigation": "awsui_show-navigation_hyvsj_znou3_626",
  "animating": "awsui_animating_hyvsj_znou3_648",
  "showButtons": "awsui_showButtons_hyvsj_znou3_1",
  "navigation": "awsui_navigation_hyvsj_znou3_591",
  "openNavigation": "awsui_openNavigation_hyvsj_znou3_1",
  "animated-content": "awsui_animated-content_hyvsj_znou3_709",
  "hide-navigation": "awsui_hide-navigation_hyvsj_znou3_718",
  "notifications": "awsui_notifications_hyvsj_znou3_224",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_znou3_785",
  "position-bottom": "awsui_position-bottom_hyvsj_znou3_820",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_znou3_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_znou3_849",
  "position-side": "awsui_position-side_hyvsj_znou3_877",
  "openSplitPanelSide": "awsui_openSplitPanelSide_hyvsj_znou3_1",
  "tools-container": "awsui_tools-container_hyvsj_znou3_914",
  "tools": "awsui_tools_hyvsj_znou3_914",
  "openTools": "awsui_openTools_hyvsj_znou3_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_znou3_999",
  "hide-tools": "awsui_hide-tools_hyvsj_znou3_1009",
  "show-tools": "awsui_show-tools_hyvsj_znou3_1021",
  "has-tools-form": "awsui_has-tools-form_hyvsj_znou3_999",
  "trigger": "awsui_trigger_hyvsj_znou3_1078",
  "selected": "awsui_selected_hyvsj_znou3_1117"
};